import * as tslib_1 from "tslib";
import { throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { FASTLINK, STANDARD_FLOW } from '../constants';
import { HttpClient } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var FinAppToolService = /** @class */ (function () {
    function FinAppToolService(http) {
        this.http = http;
        this.instanceLoaded = false;
        // for logout purposes needed to make sure only singelton of service is created
        return FinAppToolService.instance = FinAppToolService.instance || this;
    }
    // testing yodlee / envestnet login
    FinAppToolService.prototype.invokeEnvestnetLogin = function (appToLaunch, extraParams) {
        var _this = this;
        var baseApi = '/api/secure';
        var url = baseApi + '/external-services/v1/envestnet/login';
        return this.http
            .post(url, {}).
            pipe(map(function (response) {
            // console.log('[envestnet login response: ]', response);
            return _this.transformEnvestnetResponse(response, appToLaunch, extraParams);
        }), catchError(function (error) {
            return throwError('An error occurred during the request.' + error);
        }));
    };
    FinAppToolService.prototype.transformEnvestnetResponse = function (data, appToLaunch, extraParams) {
        var e_1, _a;
        var finAppInfo = { url: '', appId: 0, rsession: '', token: '', redirectReq: true, extraParams: '' };
        if (!data) {
            return null;
        }
        try {
            for (var _b = tslib_1.__values(data['apps']), _c = _b.next(); !_c.done; _c = _b.next()) {
                var app = _c.value;
                if (app) {
                    if (appToLaunch && app['finAppName'] === appToLaunch) {
                        this.assignFinAppResponseValues(app, finAppInfo);
                        if (appToLaunch.includes(FASTLINK)) {
                            finAppInfo.extraParams = extraParams ? this.setExtraParams(extraParams) : '';
                        }
                        else {
                            finAppInfo.extraParams = '';
                        }
                        break;
                    }
                    if (!appToLaunch && app['finAppName'].includes(FASTLINK)) {
                        this.assignFinAppResponseValues(app, finAppInfo);
                        finAppInfo.extraParams = extraParams ? this.setExtraParams(extraParams) : '';
                        break;
                    }
                }
                /**
                 * CAN ADD NEEDED CHECK TO LAUNCH ANY YODLEE FINAPP APPLICATION SENT BACK IN THE RESPONSE,
                 * ALL APPLICATIONS NEED SIMILAR INFORMATION TO LAUNCH
                 */
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return finAppInfo;
    };
    FinAppToolService.prototype.assignFinAppResponseValues = function (app, finAppInfo) {
        finAppInfo.url = app['url'];
        finAppInfo.appId = app['attributes']['app'];
        finAppInfo.rsession = app['attributes']['rsession'];
        finAppInfo.token = app['attributes']['token'];
        finAppInfo.redirectReq = app['attributes']['redirectReq'];
        return;
    };
    FinAppToolService.prototype.refreshAccount = function (rsession) {
        var baseApi = '/api/secure';
        var url = baseApi + '/external-services/v1/yodlee/refreshaccounts';
        var headers = new HttpHeaders();
        headers = headers.append('Content-Type', 'application/json');
        headers = headers.append('yodlee-user-session', rsession ? rsession : this.getRsession());
        return this.http
            .put(url, {}, { observe: 'response', headers: headers })
            .pipe(map(function (response) { return response; }), catchError(function (error) {
            var message = error.statusText === '' ? 'An error occurred during the request.' : error.statusText;
            return throwError(message);
        }));
    };
    FinAppToolService.prototype.yodleeLogout = function (rsession) {
        var baseApi = '/api/secure';
        var url = baseApi + '/external-services/v1/yodlee/user/logout';
        var headers = new HttpHeaders();
        headers = headers.append('Content-Type', 'application/json');
        headers = headers.append('yodlee-user-session', rsession ? rsession : this.getRsession());
        return this.http
            .post(url, {}, { headers: headers })
            .pipe(map(function (response) { return response; }), catchError(function (error) {
            var message = error.statusText === '' ? 'An error occurred during the request.' : error.statusText;
            return throwError(message);
        }));
    };
    FinAppToolService.prototype.setRsession = function (currRsession) {
        this.rsession = currRsession || '';
    };
    FinAppToolService.prototype.getRsession = function () {
        return this.rsession;
    };
    FinAppToolService.prototype.cleanUpYodlee = function () {
        var _this = this;
        var match = document.cookie.match(new RegExp('(^| )' + 'VisitedSystems' + '=([^;]+)'));
        var visitedSystems = match[2];
        if (visitedSystems) {
            visitedSystems = visitedSystems.replace('FINAPP=ON', '');
            document.cookie = 'VisitedSystems=' + visitedSystems + '; path=/; domain=.prudential.com; Secure; SameSite=Lax;';
        }
        this.refreshAccount().subscribe(function (res) {
            if (res.status === 202) {
                _this.yodleeLogout().subscribe(function () {
                });
            }
        }, function (error) {
            _this.yodleeLogout().subscribe(function () {
            });
        });
    };
    // This function returns static cdn image url
    // This is callback Url from Yodlee when "All Done" button clicked within Finapp
    FinAppToolService.prototype.getCallbackUrl = function () {
        // loading dots
        return 'https%3A%2F%2Fcdn.pficdn.com%2Flink-cms%2Fcms%2Ftheme-assets%2Fimages%2Floading-app.gif';
        // close modal with 'X' image
        // return 'https%3A%2F%2Fcdn.pficdn.com%2Flink-cms%2Fcms%2Ftheme-assets%2Fimages%2FFinapp_close_message_light.png';
    };
    FinAppToolService.prototype.setExtraParams = function (extraParams) {
        var location = window.location.href;
        if (extraParams.includes(STANDARD_FLOW)) {
            extraParams = '';
        }
        else {
            extraParams = extraParams + '&';
        }
        var updatedExtraParams = extraParams + 'iframeResize=true&postSource=link' +
            '&locationurl=' + location + '&callback=' + this.getCallbackUrl();
        return updatedExtraParams;
    };
    FinAppToolService.ngInjectableDef = i0.defineInjectable({ factory: function FinAppToolService_Factory() { return new FinAppToolService(i0.inject(i1.HttpClient)); }, token: FinAppToolService, providedIn: "root" });
    return FinAppToolService;
}());
export { FinAppToolService };
